import Vue from '../../../../../assets/vendor/vue/dist/vue.min';
import Loader from '../partials/loader';
import DateSlider from '../partials/date-slider';

export default class TVGuide {
    constructor($block) {
        this.$block = $block;
        this.$wrapper = this.$block.querySelector('[data-tv-guide]');

        this.initVueApp();
    }

    initVueApp() {
        const blockId = this.$block.dataset.blockId;
        new Vue({
            delimiters: ['v{', '}'],
            el: this.$wrapper,
            data: {
                loader: null,
                slider: null,
                programs: []
            },
            methods: {
                async getPrograms() {
                    this.loader.loading(true);

                    let activeDate = this.slider.getActiveDate();

                    let result = await this.update(activeDate);
                    this.programs = result;
                    this.loader.loading(false);
                },
                async update(date) {

                    /**
                     * @todo This URL changes in Blueprints:
                     *
                     * {host}/block/{blockId}/ajax/get-tv-guide?date=d-m-Y
                     *
                     * @see \Core\Blueprints\Block\Program\Controller\TvGuideController::getTvGuide
                     */

                    const request = await fetch(
                            placeholders.router.request + '/block/' + blockId + '/ajax/get-tv-guide?date=' + date,
                    {
                        method: 'get',
                                headers: {
                        'Accept': 'application/json',
                                'Content-Type': 'application/json'
                    },
                    }
                );
                    const result = await request.json();
                    return result;
                }
            },
            mounted () {
                this.loader = (new Loader(document.querySelector('[data-loader]')));
                this.slider = (new DateSlider(this.$refs.slider));
                this.slider.init();

                this.slider.slider.on('slideChange', this.getPrograms);
                this.getPrograms();

            }
        });

    }
}